import { noteActions, patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import _ from 'lodash';

const initialState = {
    PTEVAL: {},
    PTNOTE: {},
    PTOBJECTIVETEMPLATESXREF: {},
    PTOBJECTIVEASTERISKS: {},
    PTOBJECTIVEOBS: {},
    PTOBJECTIVEACCJOINTMOB: {},
    PTOBJECTIVEPALP: {},
    PTOBJECTIVEROM: {},
    PTOBJECTIVESTR: {},
    PTOBJECTIVESPECTESTS: {},
    PTOUTMEASURES: {},
    PTOBJECTIVEPEDS: {},
    PTOBJECTIVEPEDSMUSCU: {},
    PTOBJECTIVEPEDSTONE: {},
    PTOBJECTIVESPEECH: {},
    PTGOALS: {},
    PTSHORTGOALS: {},
    PTASSESSMENT: {},
    PTASSESSMENTFLAGS: {},
    PTPLAN: {},
    PTPLANTIMEDMODALITIES: {},
    PTPLANUNTIMEDMODALITIES: {},
    PTPLANUNTIMEDOTHER: {},
    PTADDENDUM: {},
    PTNOTEAUDIT: {},
    PTSCRIBELOG: {},
    MLEXLOG: {},
    MLAQUATICS: {},
    MLEVAL: {},
    MLFCEPOET: {},
    MLGAIT: {},
    MLMANUAL: {},
    MLMODALITIES: {},
    MLNEURO: {},
    MLOTHER: {},
    MLPHYSRECOND: {},
    MLSELFCARE: {},
    MLSPECIALTYTESTS: {},
    MLSPEECH: {},
    MLTHERACT: {},
    MLTHEREX: {},
    MLWORKHARD: {},
    CWPAINSCREENING: {},
    PTEVALPEDS: {},
    CPEPISODE: {},
    PTOBJECTIVETEMPLATES: {},
    PTOBJECTIVETEMPLATEPANELXREF: {},
    FOTOPATIENTRESPONSE: {},
    EVALCODES: {},
    MLTEMPLATE: {},
    PTGOALTEMPLATE: {},
    PTGOALTEMPLATEDETAILS: {},
    PTOBJECTIVEMATHAND: {},
    PTOBJECTIVENONMATHAND: {},
    PTGOALFAVORITES: {},
    SUPV: {},
    MLCHARGEREQUESTS: {},
    MLCOMPUTEDCHARGES: {},
    PTNOTEUPDATES: {},
    PTSUBJECTIVE: {},
    PTSUBJECTIVEPREV: {},
    PTEVALSUBJECTIVE: {},
    MLAQUATICSPREV: {},
    MLGAITPREV: {},
    MLMANUALPREV: {},
    MLMODALITIESPREV: {},
    MLNEUROPREV: {},
    MLOTHERPREV: {},
    MLSELFCAREPREV: {},
    MLSPECIALTYTESTSPREV: {},
    MLSPEECHPREV: {},
    MLTHERACTPREV: {},
    MLTHEREXPREV: {},
    PTASSESSMENTPREV: {},
    PTPAINPREV: {},
    PTOBJECTIVEROMPREV: {},
    PTOBJECTIVESTRPREV: {},
    CILIST: {}
};

export const reducer = createReducer(initialState, {
    [noteActions.loadInProgNoteSuccess]: (state, action) => {
        return _.merge(state, action.payload.noteData.entities);
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let newState = { ...state, ...action.payload.notesContainer.entities }
        delete newState["notes"];
        return newState;
    },
    [noteActions.updateTextFieldSuccess]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = action.payload.value;
    },
    [noteActions.updateBitFieldSuccess]: (state, action) => {
        console.log(action.payload);
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = action.payload.value;
    },
    [noteActions.updateIntFieldSuccess]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = action.payload.value;
    },
    [noteActions.updateALTimeSuccess]: (state, action) => {
        state.MLEXLOG[action.payload.xlno][action.payload.field] = action.payload.toTime;
        state.MLEXLOG[action.payload.xlno][action.payload.field + 'ASSIST'] = action.payload.asTime;
        state.MLEXLOG[action.payload.xlno][action.payload.field + + 'THERAPIST'] = action.payload.thTime;
    },
    [noteActions.updateDecimalFieldSuccess]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = action.payload.value;
    },
    [noteActions.updateDateFieldSuccess]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = action.payload.value;
    },
    [noteActions.clearFieldSuccess]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = null;
    },
    [patientActions.refreshFotoResponseSuccess]: (state, action) => {
        Object.values(state.PTOUTMEASURES).forEach(x => {
            Object.values(action.payload.entities.PTOUTMEASURES).forEach(y => {
                if (x.NoteId === y.NoteId) {
                    delete state.PTOUTMEASURES[x.OMNO];
                }
            })
        })
        state.PTOUTMEASURES = _.merge(state.PTOUTMEASURES, action.payload.entities.PTOUTMEASURES);
    },
    [patientActions.refreshFotoMessuresResponseSuccess]: (state, action) => {
        console.log(action);
        console.log(action.payload.fotoRefresh.entities.FOTOPATIENTRESPONSE);
        console.log(action.payload.noteID);



        // Object.values(state.FOTOPATIENTRESPONSE).forEach(x => {
        //     Object.values(action.payload.fotoRefresh.entities?.FOTOPATIENTRESPONSE).forEach(y => {
        //         if (x.NoteId === y.NoteId) {
        //             delete state.FOTOPATIENTRESPONSE[x.FOTOPRNO];
        //         }
        //     })
        // })

        //remove incoming foto repsonce
        Object.values(state.FOTOPATIENTRESPONSE).forEach(x => {
            if (x.NoteId === action.payload.noteID) {
                delete state.FOTOPATIENTRESPONSE[x.FOTOPRNO];
            }
        })

        state.FOTOPATIENTRESPONSE = _.merge(state.FOTOPATIENTRESPONSE, action.payload.fotoRefresh.entities.FOTOPATIENTRESPONSE);

    },
    [noteActions.clearFieldsSuccess]: (state, action) => {
        action.payload.fields.forEach(element => {
            state[action.payload.entity][action.payload.entityKeyValue][element] = null;
        });
    },
    [noteActions.clearSpineFieldsSuccess]: (state, action) => {
        let type = parseInt(action.payload.noteId.split("_")[0]);
        let pk = parseInt(action.payload.noteId.split("_")[1]);
        let rono = undefined;
        let asno = undefined;
        if (type === 1) {
            rono = Object.keys(state.PTOBJECTIVEROM)
                .find(x => (state.PTOBJECTIVEROM[x].ROEVNO === pk));
            asno = parseInt(Object.keys(state.PTASSESSMENT)
                .find(x => (state.PTASSESSMENT[x].ASEVNO === pk)));
        } else {
            rono = Object.keys(state.PTOBJECTIVEROM)
                .find(x => (state.PTOBJECTIVEROM[x].RONTNO === pk));
            asno = parseInt(Object.keys(state.PTASSESSMENT)
                .find(x => (state.PTASSESSMENT[x].ASNTNO === pk)));
        }
        let fields = [
            'ROCERVICALFLEXIONPROM',
            'ROCERVICALFLEXIONAROM',
            'ROCERVICALEXTENSIONPROM',
            'ROCERVICALEXTENSIONAROM',
            'ROCERVICALLATFLEXIONPROMR',
            'ROCERVICALLATFLEXIONPROML',
            'ROCERVICALLATFLEXIONAROMR',
            'ROCERVICALLATFLEXIONAROML',
            'ROCERVICALROTATIONPROMR',
            'ROCERVICALROTATIONPROML',
            'ROCERVICALROTATIONAROMR',
            'ROCERVICALROTATIONAROML',
            'ROTHORACICFLEXIONPROM',
            'ROTHORACICFLEXIONAROM',
            'ROTHORACICEXTENSIONPROM',
            'ROTHORACICEXTENSIONAROM',
            'ROTHORACICLATFLEXIONPROMR',
            'ROTHORACICLATFLEXIONPROML',
            'ROTHORACICLATFLEXIONAROMR',
            'ROTHORACICLATFLEXIONAROML',
            'ROTHORACICROTATIONPROMR',
            'ROTHORACICROTATIONPROML',
            'ROTHORACICROTATIONAROMR',
            'ROTHORACICROTATIONAROML',
            'ROLUMBARFLEXIONPROM',
            'ROLUMBARFLEXIONAROM',
            'ROLUMBAREXTENSIONPROM',
            'ROLUMBAREXTENSIONAROM',
            'ROLUMBARLATFLEXIONPROMR',
            'ROLUMBARLATFLEXIONPROML',
            'ROLUMBARLATFLEXIONAROMR',
            'ROLUMBARLATFLEXIONAROML',
            'ROLUMBARROTATIONPROMR',
            'ROLUMBARROTATIONPROML',
            'ROLUMBARROTATIONAROMR',
            'ROLUMBARROTATIONAROML'
        ];

        fields.forEach(element => {
            state.PTOBJECTIVEROM[rono][element] = null;
        });

        let flags = Object.keys(state.PTASSESSMENTFLAGS)
            .filter(x => {
                return (
                    state.PTASSESSMENTFLAGS[x].AFASNO === asno
                    && (
                        action.payload.degreeKeys.includes(state.PTASSESSMENTFLAGS[x].AFMOPNO)
                        || action.payload.percentKeys.includes(state.PTASSESSMENTFLAGS[x].AFMOPNO)
                    )
                );
            })

        flags.forEach(element => {
            delete state.PTASSESSMENTFLAGS[element];
        });


    },
    [noteActions.updateContrainSuccess]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue][action.payload.field] = action.payload.value;
    },
    [noteActions.addTemplateSuccess]: (state, action) => {
        let type = parseInt(action.payload.noteId.split("_")[0]);
        let pk = parseInt(action.payload.noteId.split("_")[1]);
        var template;

        if (type === 1) {
            template = {
                NoteId: action.payload.noteId,
                OBNO: action.payload.obno,
                OBEVNO: pk,
                OBTENO: action.payload.teno
            }
        } else {
            template = {
                NoteId: action.payload.noteId,
                OBNO: action.payload.obno,
                OBNTNO: pk,
                OBTENO: action.payload.teno
            }
        }
        state.PTOBJECTIVETEMPLATESXREF[action.payload.obno] = template;
    },
    [noteActions.removeTemplateSuccess]: (state, action) => {
        let type = parseInt(action.payload.noteId.split("_")[0]);
        let pk = parseInt(action.payload.noteId.split("_")[1]);

        let entry;
        if (type === 1) {
            entry = Object.keys(state.PTOBJECTIVETEMPLATESXREF)
                .find(x => state.PTOBJECTIVETEMPLATESXREF[x].OBEVNO === pk &&
                    state.PTOBJECTIVETEMPLATESXREF[x].OBTENO === action.payload.teno);
        } else {
            entry = Object.keys(state.PTOBJECTIVETEMPLATESXREF)
                .find(x => state.PTOBJECTIVETEMPLATESXREF[x].OBNTNO === pk &&
                    state.PTOBJECTIVETEMPLATESXREF[x].OBTENO === action.payload.teno);
        }

        delete state.PTOBJECTIVETEMPLATESXREF[entry];
    },
    [noteActions.addChildRowSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addCustomGoalSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addGoalDetailTemplateSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addIndHepGoalSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addChildRowGeneratorSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addAlRowSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.removeChildRowSuccess]: (state, action) => {
        delete state[action.payload.table][action.payload.pk];
    },
    [noteActions.updateAlModFieldSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.updateAlOtherFieldSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.clearAlSuccess]: (state, action) => {
        let xlno = parseInt(Object.keys(action.payload.response.entities.MLEXLOG)[0]);
        let keys;

        if (state.MLAQUATICS) {
            keys = Object.keys(state.MLAQUATICS)
                .filter(x => state.MLAQUATICS[x].XLAQXLNO === xlno);
            keys.forEach(x => delete state.MLAQUATICS[x]);
        }

        if (state.MLEVAL) {
            keys = Object.keys(state.MLEVAL)
                .filter(x => state.MLEVAL[x].XLEVXLNO === xlno);
            keys.forEach(x => delete state.MLEVAL[x]);
        }

        if (state.MLGAIT) {
            keys = Object.keys(state.MLGAIT)
                .filter(x => state.MLGAIT[x].XLGAXLNO === xlno);
            keys.forEach(x => delete state.MLGAIT[x]);
        }

        if (state.MLMANUAL) {
            keys = Object.keys(state.MLMANUAL)
                .filter(x => state.MLMANUAL[x].XLMAXLNO === xlno);
            keys.forEach(x => delete state.MLMANUAL[x]);
        }

        if (state.MLMODALITIES) {
            keys = Object.keys(state.MLMODALITIES)
                .filter(x => state.MLMODALITIES[x].XLMDXLNO === xlno);
            keys.forEach(x => delete state.MLMODALITIES[x]);
        }

        if (state.MLNEURO) {
            keys = Object.keys(state.MLNEURO)
                .filter(x => state.MLNEURO[x].XLNEXLNO === xlno);
            keys.forEach(x => delete state.MLNEURO[x]);
        }

        if (state.MLOTHER) {
            keys = Object.keys(state.MLOTHER)
                .filter(x => state.MLOTHER[x].XLOEXLNO === xlno);
            keys.forEach(x => delete state.MLOTHER[x]);
        }

        if (state.MLPHYSRECOND) {
            keys = Object.keys(state.MLPHYSRECOND)
                .filter(x => state.MLPHYSRECOND[x].XLPRXLNO === xlno);
            keys.forEach(x => delete state.MLPHYSRECOND[x]);
        }

        if (state.MLSELFCARE) {
            keys = Object.keys(state.MLSELFCARE)
                .filter(x => state.MLSELFCARE[x].XLSCXLNO === xlno);
            keys.forEach(x => delete state.MLSELFCARE[x]);
        }

        if (state.MLSPECIALTYTESTS) {
            keys = Object.keys(state.MLSPECIALTYTESTS)
                .filter(x => state.MLSPECIALTYTESTS[x].XLSZXLNO === xlno);
            keys.forEach(x => delete state.MLSPECIALTYTESTS[x]);
        }

        if (state.MLTHERACT) {
            keys = Object.keys(state.MLTHERACT)
                .filter(x => state.MLTHERACT[x].XLTAXLNO === xlno);
            keys.forEach(x => delete state.MLTHERACT[x]);
        }

        if (state.MLTHEREX) {
            keys = Object.keys(state.MLTHEREX)
                .filter(x => state.MLTHEREX[x].XLTEXLNO === xlno);
            keys.forEach(x => delete state.MLTHEREX[x]);
        }

        if (state.MLWORKHARD) {
            keys = Object.keys(state.MLWORKHARD)
                .filter(x => state.MLWORKHARD[x].XLWHXLNO === xlno);
            keys.forEach(x => delete state.MLWORKHARD[x]);
        }

        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.getAlTemplateSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },

    [noteActions.getNoteWarningSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },

    [noteActions.alTemplateToggleItem]: (state, action) => {
        state[action.payload.entity][action.payload.entityKeyValue].selected = !state[action.payload.entity][action.payload.entityKeyValue].selected;
    },
    [noteActions.cancelAlTemplate]: (state, action) => {
        if (state.MLTMPTHERACT) {
            delete state.MLTMPTHERACT;
        }
        if (state.MLTMPSELFCARE) {
            delete state.MLTMPSELFCARE;
        }
        if (state.MLTMPNEURO) {
            delete state.MLTMPNEURO;
        }
        if (state.MLTMPTHEREX) {
            delete state.MLTMPTHEREX;
        }
        if (state.MLTMPMANUAL) {
            delete state.MLTMPMANUAL;
        }
        if (state.MLTMPGAIT) {
            delete state.MLTMPGAIT;
        }
        if (state.MLTMPAQUATICS) {
            delete state.MLTMPAQUATICS;
        }
        if (state.MLTMPMODALITIES) {
            delete state.MLTMPMODALITIES;
        }
        if (state.MLTMPOTHER) {
            delete state.MLTMPOTHER;
        }
        if (state.MLTMPSPECIALTYTESTS) {
            delete state.MLTMPSPECIALTYTESTS;
        }
    },
    [noteActions.alTemplateToggleAllSelected]: (state, action) => {
        if (action.payload.value === false) {
            if (state.MLTMPTHERACT) {
                let keys = Object.keys(state.MLTMPTHERACT);
                keys.forEach(x => {
                    state.MLTMPTHERACT[x].selected = false;
                })
            }
            if (state.MLTMPSELFCARE) {
                let keys = Object.keys(state.MLTMPSELFCARE);
                keys.forEach(x => {
                    state.MLTMPSELFCARE[x].selected = false;
                })
            }
            if (state.MLTMPNEURO) {
                let keys = Object.keys(state.MLTMPNEURO);
                keys.forEach(x => {
                    state.MLTMPNEURO[x].selected = false;
                })
            }
            if (state.MLTMPTHEREX) {
                let keys = Object.keys(state.MLTMPTHEREX);
                keys.forEach(x => {
                    state.MLTMPTHEREX[x].selected = false;
                })
            }
            if (state.MLTMPMANUAL) {
                let keys = Object.keys(state.MLTMPMANUAL);
                keys.forEach(x => {
                    state.MLTMPMANUAL[x].selected = false;
                })
            }
            if (state.MLTMPGAIT) {
                let keys = Object.keys(state.MLTMPGAIT);
                keys.forEach(x => {
                    state.MLTMPGAIT[x].selected = false;
                })
            }
            if (state.MLTMPAQUATICS) {
                let keys = Object.keys(state.MLTMPAQUATICS);
                keys.forEach(x => {
                    state.MLTMPAQUATICS[x].selected = false;
                })
            }
            if (state.MLTMPMODALITIES) {
                let keys = Object.keys(state.MLTMPMODALITIES);
                keys.forEach(x => {
                    state.MLTMPMODALITIES[x].selected = false;
                })
            }
            if (state.MLTMPOTHER) {
                let keys = Object.keys(state.MLTMPOTHER);
                keys.forEach(x => {
                    state.MLTMPOTHER[x].selected = false;
                })
            }
            if (state.MLTMPSPECIALTYTESTS) {
                let keys = Object.keys(state.MLTMPSPECIALTYTESTS);
                keys.forEach(x => {
                    state.MLTMPSPECIALTYTESTS[x].selected = false;
                })
            }

        } else {
            if (state.MLTMPTHERACT) {
                let keys = Object.keys(state.MLTMPTHERACT);
                keys.forEach(x => {
                    state.MLTMPTHERACT[x].selected = state.MLTMPTHERACT[x].valid;
                })
            }
            if (state.MLTMPSELFCARE) {
                let keys = Object.keys(state.MLTMPSELFCARE);
                keys.forEach(x => {
                    state.MLTMPSELFCARE[x].selected = state.MLTMPSELFCARE[x].valid;
                })
            }
            if (state.MLTMPNEURO) {
                let keys = Object.keys(state.MLTMPNEURO);
                keys.forEach(x => {
                    state.MLTMPNEURO[x].selected = state.MLTMPNEURO[x].valid;
                })
            }
            if (state.MLTMPTHEREX) {
                let keys = Object.keys(state.MLTMPTHEREX);
                keys.forEach(x => {
                    state.MLTMPTHEREX[x].selected = state.MLTMPTHEREX[x].valid;
                })
            }
            if (state.MLTMPMANUAL) {
                let keys = Object.keys(state.MLTMPMANUAL);
                keys.forEach(x => {
                    state.MLTMPMANUAL[x].selected = state.MLTMPMANUAL[x].valid;
                })
            }
            if (state.MLTMPGAIT) {
                let keys = Object.keys(state.MLTMPGAIT);
                keys.forEach(x => {
                    state.MLTMPGAIT[x].selected = state.MLTMPGAIT[x].valid;
                })
            }
            if (state.MLTMPAQUATICS) {
                let keys = Object.keys(state.MLTMPAQUATICS);
                keys.forEach(x => {
                    state.MLTMPAQUATICS[x].selected = state.MLTMPAQUATICS[x].valid;
                })
            }
            if (state.MLTMPMODALITIES) {
                let keys = Object.keys(state.MLTMPMODALITIES);
                keys.forEach(x => {
                    state.MLTMPMODALITIES[x].selected = state.MLTMPMODALITIES[x].valid;
                })
            }
            if (state.MLTMPOTHER) {
                let keys = Object.keys(state.MLTMPOTHER);
                keys.forEach(x => {
                    state.MLTMPOTHER[x].selected = state.MLTMPOTHER[x].valid;
                })
            }
            if (state.MLTMPSPECIALTYTESTS) {
                let keys = Object.keys(state.MLTMPSPECIALTYTESTS);
                keys.forEach(x => {
                    state.MLTMPSPECIALTYTESTS[x].selected = state.MLTMPSPECIALTYTESTS[x].valid;
                })
            }
        }
    },
    [noteActions.applyAlTemplateFailure]: (state, action) => {
        if (state.MLTMPTHERACT) {
            delete state.MLTMPTHERACT;
        }
        if (state.MLTMPSELFCARE) {
            delete state.MLTMPSELFCARE;
        }
        if (state.MLTMPNEURO) {
            delete state.MLTMPNEURO;
        }
        if (state.MLTMPTHEREX) {
            delete state.MLTMPTHEREX;
        }
        if (state.MLTMPMANUAL) {
            delete state.MLTMPMANUAL;
        }
        if (state.MLTMPGAIT) {
            delete state.MLTMPGAIT;
        }
        if (state.MLTMPAQUATICS) {
            delete state.MLTMPAQUATICS;
        }
        if (state.MLTMPMODALITIES) {
            delete state.MLTMPMODALITIES;
        }
        if (state.MLTMPOTHER) {
            delete state.MLTMPOTHER;
        }
        if (state.MLTMPSPECIALTYTESTS) {
            delete state.MLTMPSPECIALTYTESTS;
        }
    },
    [noteActions.applyAlTemplateSuccess]: (state, action) => {
        if (state.MLTMPTHERACT) {
            delete state.MLTMPTHERACT;
        }
        if (state.MLTMPSELFCARE) {
            delete state.MLTMPSELFCARE;
        }
        if (state.MLTMPNEURO) {
            delete state.MLTMPNEURO;
        }
        if (state.MLTMPTHEREX) {
            delete state.MLTMPTHEREX;
        }
        if (state.MLTMPMANUAL) {
            delete state.MLTMPMANUAL;
        }
        if (state.MLTMPGAIT) {
            delete state.MLTMPGAIT;
        }
        if (state.MLTMPAQUATICS) {
            delete state.MLTMPAQUATICS;
        }
        if (state.MLTMPMODALITIES) {
            delete state.MLTMPMODALITIES;
        }
        if (state.MLTMPOTHER) {
            delete state.MLTMPOTHER;
        }
        if (state.MLTMPSPECIALTYTESTS) {
            delete state.MLTMPSPECIALTYTESTS;
        }
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.saveAlTemplateSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.deleteAlTemplateSuccess]: (state, action) => {
        state.MLTEMPLATE = action.payload.response.entities.MLTEMPLATE;
    },
    [noteActions.undoDeleteAlTemplateSuccess]: (state, action) => {
        state.MLTEMPLATE = action.payload.response.entities.MLTEMPLATE;
    },
    [noteActions.addGoalSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.updateDatesLTGSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.updateDatesSTGSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addSTGoalSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.favoriteGoalSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.applyFavoriteGoalSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.clearGoalsSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addAssessmentFlagSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addSTGFlagSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.addPlanSubCatSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.updateAllAssessmentFlagsSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.updateAllShortGoalFlagsSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.updateAllGoalFlagsSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.clearAlGroupSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.computeChargesSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [patientActions.closeTab]: (state, action) => {
        if (action.payload.noteId && action.payload.tabId && action.payload.tabId.startsWith("IN_")) {
            // delete all the things for this NoteId
            Object.keys(state)
                .forEach(key => {
                    Object.keys(state[key])
                        .filter(key2 => state[key][key2].NoteId === action.payload.noteId)
                        .forEach(key2 => delete state[key][key2]);
                });
        }
    },
    [noteActions.saveFinalSuccess]: (state, action) => {
        if (action.payload.noteId) {
            // delete all the things for this NoteId
            Object.keys(state)
                .forEach(key => {
                    Object.keys(state[key])
                        .filter(key2 => state[key][key2].NoteId === action.payload.noteId)
                        .forEach(key2 => delete state[key][key2]);
                });
        }
    },
    [noteActions.convertSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },
    [noteActions.saveObjectiveTemplateSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities);
    },


})


